import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`bg-sage hover:bg-sage-dark text-white font-sans font-bold py-4 px-8 rounded-full transition-colors duration-300 shadow-sm hover:shadow-md ${className}`} {...props} data-id="element-12">
      {children}
    </button>;
}